var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayDiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.5C2.22973 0.5 0 2.72973 0 5.5C0 8.27027 2.22973 10.5 5 10.5H10V5.56757C10 2.7973 7.77026 0.5 5 0.5ZM2.66544 8.05071C2.54589 7.93116 2.54984 7.73338 2.67427 7.60896L7.10896 3.17426C7.23339 3.04984 7.43116 3.04589 7.55071 3.16544C7.67026 3.28498 7.66631 3.48276 7.54189 3.60718L3.10719 8.04188C2.98277 8.1663 2.78499 8.17026 2.66544 8.05071ZM4.69388 4.37755C4.69388 5.05382 4.14565 5.60204 3.46939 5.60204C2.79312 5.60204 2.2449 5.05382 2.2449 4.37755C2.2449 3.70128 2.79312 3.15306 3.46939 3.15306C4.14565 3.15306 4.69388 3.70128 4.69388 4.37755ZM3.46939 4.9898C3.80752 4.9898 4.08163 4.71568 4.08163 4.37755C4.08163 4.03942 3.80752 3.76531 3.46939 3.76531C3.13125 3.76531 2.85714 4.03942 2.85714 4.37755C2.85714 4.71568 3.13125 4.9898 3.46939 4.9898ZM6.53061 8.2551C7.20688 8.2551 7.7551 7.70688 7.7551 7.03061C7.7551 6.35435 7.20688 5.80612 6.53061 5.80612C5.85435 5.80612 5.30612 6.35435 5.30612 7.03061C5.30612 7.70688 5.85435 8.2551 6.53061 8.2551ZM7.14286 7.03061C7.14286 7.36875 6.86875 7.64286 6.53061 7.64286C6.19248 7.64286 5.91837 7.36875 5.91837 7.03061C5.91837 6.69248 6.19248 6.41837 6.53061 6.41837C6.86875 6.41837 7.14286 6.69248 7.14286 7.03061Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayDiscountIcon);
export default __webpack_public_path__ + "static/media/grayDiscountIcon.98ea17868096c2c3b32610a21010068c.svg";
export { ForwardRef as ReactComponent };